import api from '@anm/api';
import useDownloadCsv from '@anm/hooks/useDownloadCsv';

const downloadWebinarAttendees = async (streamId: string) => {
  const fetchedData = await api().stream.getWebinarAttendees(streamId);

  useDownloadCsv({ data: fetchedData, fileName: `${streamId}_attendees.csv` })();
};

export default downloadWebinarAttendees;
